import { InjectionToken } from '@angular/core'
import { FloPerfWindow, FloPerfTrackFn } from './performance-metrics.interface'
import { SchedulerLike } from 'rxjs'

export const FLO_PERF_TRACKING_PROVIDER = new InjectionToken<FloPerfTrackFn>('flo.perf.analytics')
export const FLO_PERF_WINDOW = new InjectionToken<FloPerfWindow>('flo.perf.window')
export const FLO_PERF_INTERVAL_MS = new InjectionToken<number>('flo.perf.interval')

export const FLO_PERF_SCHEDULER = new InjectionToken<SchedulerLike>('flo.perf.sched')
